module.exports = __webpack_public_path__ + "static/media/email-red.950f15af.svg";